<template>
  <a-card class="patient-fill" :bordered="false">
    <a-row>
      <a-col :span="4" >
        <a-anchor style="margin-left: 20px" class="menu-panel" :affix="true" @click="handleClickAnchor">
          <!--<a-anchor-link class="anchor-link" href="info1" title="登录方式" />-->
          <a-anchor-link class="anchor-link" href="info2" title="欢迎语" />
          <!--<a-anchor-link class="anchor-link" href="info3" title="感谢信" />-->
          <!--<a-anchor-link class="anchor-link" href="info4" title="自定义消息提醒" />-->
          <a-anchor-link class="anchor-link" href="info5" title="表单自动推送" />
          <a-anchor-link class="anchor-link" href="info6" title="量表结论展示" />
          <a-anchor-link class="anchor-link" href="info7" title="患者可视功能配置" />
          <a-anchor-link class="anchor-link" href="info8" title="其他配置" />
          <!--<a-anchor-link class="anchor-link" href="info9" title="自动终止筛选配置" />-->
          <a-anchor-link class="anchor-link" href="info10" title="多选题目，指定答案单选" />
          <a-anchor-link class="anchor-link" href="info11" title="表情方式录入" />
        </a-anchor>
      </a-col>
      <a-col :span="20" class="info-setting">
        <!--<login-setting id="info1" :projectId="projectId" :baseModel="patientFill" @ok="loadData"></login-setting>-->
        <div id="info2" class="panel">
          <div class="title">
            欢迎语
            <template >
              <a-button v-if="!welcomeEdit" class="title-btn" type="primary" @click="welcomeEditClick">设置</a-button>
              <template v-else>
                <a-button class="title-btn" type="primary" @click="welcomeEditSubmit">保存</a-button>
                <a-button class="title-btn"  @click="welcomeEditCancel">取消</a-button>
              </template>
            </template>
          </div>
          <div class='info'>
            <a-textarea v-if="welcomeEdit" v-model='welcomeStr' placeholder='输入5~100个字符' :maxLengt='100' :rows="4"></a-textarea>
            <span v-else>{{welcomeStr ||''}}</span>
          </div>
        </div>
        <!--<div id="info3" class="panel">-->
          <!--<div class="title">-->
            <!--感谢信-->
            <!--<template v-if="project.wechat ==='1'">-->
              <!--<a-button v-if="!thankEdit" class="title-btn" type="primary" @click="thankEditClick">设置</a-button>-->
              <!--<template v-else>-->
                <!--<a-button class="title-btn" type="primary" @click="thankEditSubmit">保存</a-button>-->
                <!--<a-button class="title-btn"  @click="thankEditCancel">取消</a-button>-->
              <!--</template>-->
            <!--</template>-->
          <!--</div>-->
          <!--<div class='info'>-->
            <!--<span>尚未开启微信的服务,如需启动,请联系工程师!</span>-->
            <!--<a-textarea v-if="thankEdit" v-model='thank' placeholder='输入5~200个字符' :maxLengt='500' :rows="4"></a-textarea>-->
          <!--</div>-->
        <!--</div>-->
        <!--<message-set  id="info4" :projectId="projectId"></message-set>-->

        <form-push-set id="info5" :projectId="projectId"></form-push-set>

        <scale-form-set id="info6" :projectId="projectId"></scale-form-set>
        <div id="info7" class="panel">
          <div class="title">患者可视功能配置</div>
          <a-descriptions :column="1">
            <a-descriptions-item label="历史填写记录">
              <a-switch checkedChildren="开启" unCheckedChildren="关闭" v-model="historySwitch" @change="historySwitchChange"/>
            </a-descriptions-item>
            <a-descriptions-item label="随访计划">
              <a-switch checkedChildren="开启" unCheckedChildren="关闭" v-model="planSwitch" @change="planSwitchChange"/>
            </a-descriptions-item>
            <a-descriptions-item label="受试者有联系电话查看结论">
              <a-switch checkedChildren="开启" unCheckedChildren="关闭" v-model="resultViewPhone" @change="resultViewPhoneChange"/>
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div id="info8" class="panel">
          <div class="title">其他配置</div>
          <a-descriptions :column="1">
            <a-descriptions-item label="系统质疑填写控制">
              <a-switch checkedChildren="开启" unCheckedChildren="关闭" v-model="otherConfig.sysQuestionConfig" @change="sysQuestionConfigChange"/>
            </a-descriptions-item>
            <a-descriptions-item label="是否必须顺序填写">
              <a-switch checkedChildren="开启" unCheckedChildren="关闭" v-model="otherConfig.orderInput" @change="orderInputPhoneChange"/>
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div id="info10" class="panel">
          <div class="title">多选题目，指定答案单选</div>
          <check-only-input :checkOnlyInput="patientFill.checkOnlyInput" @onsubmit="checkOnlyInputSave"></check-only-input>
        </div>
        <div id="info11" class="panel">
          <div class="title">表情方式录入</div>
          <table-form-input :tableFormInput="patientFill.tableFormInput" @onsubmit="tableFormInputSave"></table-form-input>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
  import { getAction,postAction} from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import LoginSetting from './patientFilling/LoginSetting'
  import MessageSet from './patientFilling/MessageSet'
  import FormPushSet from './patientFilling/FormPushSet'
  import ScaleFormSet from './patientFilling/ScaleFormSet'
  import CheckOnlyInput from './patientFilling/CheckOnlyInput'
  import TableFormInput from './patientFilling/TableFormInput'
  export default {
    name: 'PatientFilling',
    components: { TableFormInput,  CheckOnlyInput, ScaleFormSet, FormPushSet, MessageSet, LoginSetting },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        patientFill:{},
        project:{},
        welcomeEdit:false,
        thankEdit:false,
        welcomeStr:'',
        thank:'',

        historySwitch:false,
        planSwitch:false,
        resultViewPhone:false,

        otherConfig:{
          sysQuestionConfig:false,
          orderInput:false,
        }
      }
    },
    computed: {

    },
    mounted(){

      getAction('/management/project/queryById',{id:this.projectId}).then(res=>{
        if(res.success){
          this.project = res.result
        }
      })
      this.loadData()
    },
    methods:{
      loadData(){
        getAction('/project/projectPatientFill/getOne',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.patientFill = res.result[0]
            this.historySwitch = this.patientFill.inputHistory==='1'
            this.planSwitch = this.patientFill.periodPlan==='1'
            this.resultViewPhone = this.patientFill.resultViewPhone==='1'
            this.welcomeStr = this.patientFill.welcome
            //其他回显
            // otherConfig:{
            //   sysQuestionConfig:false,
            //     orderInput:false,
            //     checkOnlyInput:false
            // }
            this.otherConfig = {
              sysQuestionConfig : this.patientFill.sysQuestionConfig==='1',
              orderInput : this.patientFill.orderInput==='1',
            }
          }
        })
      },
      handleClickAnchor(e, link) {
        e.preventDefault();
        const srcolls = document.getElementById(link.href);
        if(srcolls){
          srcolls.scrollIntoView({block: 'start', behavior: 'smooth'});
        }
      },
      welcomeEditClick(){
        this.welcomeEdit = true
        this.welcome = this.patientFill.welcome
      },
      thankEditClick(){
        this.thankEdit = true
        this.thank = this.patientFill.thankEdit
      },
      welcomeEditCancel(){
        this.welcome=''
        this.welcomeEdit = false
      },
      welcomeEditSubmit(){
        postAction('/project/projectPatientFill/editWelcome',{welcome:this.welcomeStr,id:this.patientFill.id}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.welcomeEditCancel()
            this.loadData()
          }
        })
      },

      thankEditCancel(){
        this.thank=''
        this.thankEdit = false
      },
      thankEditSubmit(){
        this.thankEditCancel()
      },

      historySwitchChange(){
        const inputHistory = this.historySwitch?'1':'0'
        postAction('/project/projectPatientFill/editInputHistory',{inputHistory:inputHistory,id:this.patientFill.id}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData()
          }
        })
      },
      planSwitchChange(){
        const periodPlan = this.planSwitch?'1':'0'
        postAction('/project/projectPatientFill/editPeriodPlan',{periodPlan:periodPlan,id:this.patientFill.id}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData()
          }
        })
      },
      resultViewPhoneChange(){
        const resultViewPhone = this.resultViewPhone?'1':'0'
        postAction('/project/projectPatientFill/editResultViewPhone',{resultViewPhone:resultViewPhone,id:this.patientFill.id}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData()
          }
        })
      },
      sysQuestionConfigChange(){
        const sysQuestionConfig = this.otherConfig.sysQuestionConfig?'1':'0'
        postAction('/project/projectPatientFill/editSysQuestionConfig',{sysQuestionConfig:sysQuestionConfig,id:this.patientFill.id}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData()
          }
        })
      },
      orderInputPhoneChange(){
        const orderInput = this.otherConfig.orderInput?'1':'0'
        postAction('/project/projectPatientFill/editOrderInput',{orderInput:orderInput,id:this.patientFill.id}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData()
          }
        })
      },
      checkOnlyInputSave(checkOnlyInput){
        postAction('/project/projectPatientFill/editCheckOnlyInput',{checkOnlyInput:checkOnlyInput,id:this.patientFill.id}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData()
          }
        })
      },
      tableFormInputSave(tableFormInput){
        postAction('/project/projectPatientFill/editTableFormInput',{tableFormInput:tableFormInput,id:this.patientFill.id}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData()
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
.patient-fill{
  .anchor-link{
    margin-bottom: 30px;
    font-size: 16px;
  }
  .info-setting{
    height: calc(100vh - 180px);
    overflow-y: auto;
    border-left: 1px solid rgba(0,0,0,0.2);
  }
  .menu-panel{
    /*height: calc(100vh - 180px);*/
  }
  .input{
    width: 300px;
  }


}
</style>
<style lang="less">
.patient-fill{
  .ant-anchor-wrapper{
    max-height: none !important;
  }
  .title{
    font-size: 16px;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 5px solid @primary-color;

    //background-color: #f7fafc;
    line-height: 32px;
    color: #333333;
  }
  .panel{
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 30px;

    .title-btn-panel{
      text-align: right;
    }
    .title-btn{
      margin-left: 10px;
      float: right;
    }
    .info{
      margin-left: 25px;
    }
    .base-info-item{
      margin-bottom: 10px;
    }
    .tb-panel{
      width: 800px;
    }

  }
}
</style>
